import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type TourDurationCellEmptyRunsProps = {
  emptyRunsCount: number;
  totalEmptyRunsDistanceMeters: number;
};

export const TourDurationCellEmptyRuns: React.FC<
  TourDurationCellEmptyRunsProps
> = ({ emptyRunsCount, totalEmptyRunsDistanceMeters }) => {
  const [t] = useTranslation('tours');
  return (
    <Typography variant="inherit" fontWeight={300}>
      {(totalEmptyRunsDistanceMeters / 1000).toFixed(1)} km
      <Box component="span" sx={{ mx: 2 }}>
        •
      </Box>
      {t('emptyRunsCount', {
        count: emptyRunsCount,
      })}
    </Typography>
  );
};
